"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackgroundCheckPackageScreeningDto = instanceOfBackgroundCheckPackageScreeningDto;
exports.BackgroundCheckPackageScreeningDtoFromJSON = BackgroundCheckPackageScreeningDtoFromJSON;
exports.BackgroundCheckPackageScreeningDtoFromJSONTyped = BackgroundCheckPackageScreeningDtoFromJSONTyped;
exports.BackgroundCheckPackageScreeningDtoToJSON = BackgroundCheckPackageScreeningDtoToJSON;
exports.BackgroundCheckPackageScreeningDtoToJSONTyped = BackgroundCheckPackageScreeningDtoToJSONTyped;
/**
 * Check if a given object implements the BackgroundCheckPackageScreeningDto interface.
 */
function instanceOfBackgroundCheckPackageScreeningDto(value) {
    if (!('externalServiceSubtype' in value) || value['externalServiceSubtype'] === undefined)
        return false;
    if (!('externalServiceId' in value) || value['externalServiceId'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
function BackgroundCheckPackageScreeningDtoFromJSON(json) {
    return BackgroundCheckPackageScreeningDtoFromJSONTyped(json, false);
}
function BackgroundCheckPackageScreeningDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'externalServiceSubtype': json['externalServiceSubtype'],
        'externalServiceId': json['externalServiceId'],
        'label': json['label'],
    };
}
function BackgroundCheckPackageScreeningDtoToJSON(json) {
    return BackgroundCheckPackageScreeningDtoToJSONTyped(json, false);
}
function BackgroundCheckPackageScreeningDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'externalServiceSubtype': value['externalServiceSubtype'],
        'externalServiceId': value['externalServiceId'],
        'label': value['label'],
    };
}
//# sourceMappingURL=BackgroundCheckPackageScreeningDto.js.map